/* eslint-disable no-unused-vars */
import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Pickers(theme: Theme) {
  return {}
}
